/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ActionTypeEnum = 'Other' | 'Create' | 'Update' | 'Delete' | 'RoleChange' | 'Processed' | 'Printed' | 'DeepLink' | 'PurchaseRights' | 'Ticketshop' | 'Text' | 'PaymentMethods' | 'Availability' | 'Business' | 'UpdatePrice' | 'ChannelChange' | 'DeliveryMethods' | 'Anonymised' | 'UnlinkFromSSO' | 'PassePartouts' | 'PriceSettings' | 'UpdateMarks' | 'ExternalTicketsSettings' | 'CreateWorkflowAction' | 'UpdateWorkflowAction' | 'DeleteWorkflowAction' | 'CopyWorkflowRule' | 'Impersonation';

export const ActionTypeEnum = {
    Other: 'Other' as ActionTypeEnum,
    Create: 'Create' as ActionTypeEnum,
    Update: 'Update' as ActionTypeEnum,
    Delete: 'Delete' as ActionTypeEnum,
    RoleChange: 'RoleChange' as ActionTypeEnum,
    Processed: 'Processed' as ActionTypeEnum,
    Printed: 'Printed' as ActionTypeEnum,
    DeepLink: 'DeepLink' as ActionTypeEnum,
    PurchaseRights: 'PurchaseRights' as ActionTypeEnum,
    Ticketshop: 'Ticketshop' as ActionTypeEnum,
    Text: 'Text' as ActionTypeEnum,
    PaymentMethods: 'PaymentMethods' as ActionTypeEnum,
    Availability: 'Availability' as ActionTypeEnum,
    Business: 'Business' as ActionTypeEnum,
    UpdatePrice: 'UpdatePrice' as ActionTypeEnum,
    ChannelChange: 'ChannelChange' as ActionTypeEnum,
    DeliveryMethods: 'DeliveryMethods' as ActionTypeEnum,
    Anonymised: 'Anonymised' as ActionTypeEnum,
    UnlinkFromSSO: 'UnlinkFromSSO' as ActionTypeEnum,
    PassePartouts: 'PassePartouts' as ActionTypeEnum,
    PriceSettings: 'PriceSettings' as ActionTypeEnum,
    UpdateMarks: 'UpdateMarks' as ActionTypeEnum,
    ExternalTicketsSettings: 'ExternalTicketsSettings' as ActionTypeEnum,
    CreateWorkflowAction: 'CreateWorkflowAction' as ActionTypeEnum,
    UpdateWorkflowAction: 'UpdateWorkflowAction' as ActionTypeEnum,
    DeleteWorkflowAction: 'DeleteWorkflowAction' as ActionTypeEnum,
    CopyWorkflowRule: 'CopyWorkflowRule' as ActionTypeEnum,
    Impersonation: 'Impersonation' as ActionTypeEnum
};

